/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMIntertoysPurchasePayload } from '@/data/types/GTM';
import { sendGTMIntertoysPurchaseEvent } from '../handlers/gtm/IntertoysPurchase';

export type IntertoysPurchaseDelegatorProps = {
	gtm?: GTMIntertoysPurchasePayload;
};
export const IntertoysPurchaseDelegator = async (payload: IntertoysPurchaseDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMIntertoysPurchaseEvent(gtm);
	}
};